<template>
    <div class="PaymentHelp">
        <!-- s: header -->
        <header id="header-slidePanel">
            <h2>결제방법보기</h2>
            <div class="btn_back">
                <a @click="slidePanelClose"><img src="@/assets/images/btn_back.png" width="50" alt="이전" /></a>
            </div>
        </header>
        <!-- e: header -->
        <!-- s: contents -->
        <div class="contents-area-slidePanel">
            <h3 class="mrg-top-15">결제는 PC에서만 가능합니다.</h3>
            <h2 class="mrg-top-10">모비고 홈페이지 우측에 사용권 구매<br/>“결제하기”메뉴를 눌러서 결제할 수 있습니다.</h2>
            <div class="mrg-top-20">
                <img src="@/assets/images/bg-payment-help.png" width="100%" />
            </div>
        </div>
        <!-- e: contents -->
    </div>
</template>

<script>
export default {
    name: 'PaymentHelp',
    data() {
        return {
            paymentTab:'use'
        }
    },
    // 감시자
    watch: {
    },
    // $el 생성전
    created(){
    },
    // $el 생성후
    mounted() {
        window.callbackBackKey = this.callbackBackKey;
    },
    methods: {
        // APP 뒤로가기
        callbackBackKey(){
            this.slidePanelClose();
        },
    }
}
</script>

<style scoped>
    .contents-area-slidePanel {}
    .contents-area-slidePanel h3{font-size: 14px; color: #262626;font-weight: 400}
    .contents-area-slidePanel h2{ font-size: 16px; color: #017ff0; font-weight: 400}
</style>
